import { render, staticRenderFns } from "./Contribution1.vue?vue&type=template&id=18b8e6ee&scoped=true&"
import script from "./Contribution1.vue?vue&type=script&lang=js&"
export * from "./Contribution1.vue?vue&type=script&lang=js&"
import style0 from "./Contribution1.vue?vue&type=style&index=0&id=18b8e6ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8e6ee",
  null
  
)

export default component.exports